import { TFunction } from "i18next";
import * as yup from "yup";

interface Props {
  t: TFunction;
}

const InstitutionProgramValidationSchema = ({ t }: Props) =>
  yup.array().test("hasPrograms", t("REQUIRED!"), (value) => {
    if (!value || value.length === 0) {
      return new yup.ValidationError(
        t("validations.institutionProgram"),
        value,
        "pedagogicalYearInstitutionProgramDetailId"
      );
    }
    const firstElement = value[0];
    const isValid = firstElement.canPickedOnFirstPlace === true;
    if (!isValid) {
      return new yup.ValidationError(
        t("validations.institutionProgramFirstPickError"),
        value,
        "canPickedOnFirstPlace"
      );
    } else {
      return true;
    }
  });

export default InstitutionProgramValidationSchema;
